import { swatchStyle } from "@/constants/colors";

export const ColorDots = ({ colors = [], size = 14, max = 5 }) => {
  if (!colors || colors.length === 0) return null;
  const shown = colors.slice(0, max);
  const extra = colors.length - shown.length;
  return (
    <div className="flex items-center gap-1" data-testid="color-dots">
      {shown.map((c) => (
        <span
          key={c}
          title={c}
          className="inline-block rounded-full border border-stone-300"
          style={{ width: size, height: size, ...swatchStyle(c) }}
        />
      ))}
      {extra > 0 && <span className="text-xs text-stone-400">+{extra}</span>}
    </div>
  );
};
